import React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './components/pages/Home';
import SignIn from './components/auth/SignIn';
import SignUp from './components/auth/SignUp';
import AudioEngine from './components/player/AudioEngine';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminDashboard from './components/admin/AdminDashboard';
import ComptePersonnel from './components/admin/ComptePersonnel';
import TotalBattle from './components/admin/TotalBattle';
import Minuteur from './components/admin/Minuteur';
import Culture from './components/admin/Culture';
import ForgetPassword from './components/auth/ForgetPassword';
import Layout from './components/layout/Layout';
import Dashboard from './components/utilisateur/Dashboard';
import Profile from './components/utilisateur/Profile';
import Note from './components/utilisateur/Note';
import Calendar from './components/utilisateur/Calendar';
import NotPageFound from './components/NotPageFound';
import NavBar from './components/layout/nav/NavBar';
import Footer from './components/layout/Footer';
import { ToastContainer } from 'react-toastify';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import 'react-toastify/dist/ReactToastify.css';

polyfillCountryFlagEmojis();

function App() {
  const intialTheme = {
    darkTheme: false,
    primaryColor: '#9472dc',
  };

  // Initialisation ultra-sécurisée avec un bloc try/catch
  const [themeState, setStateTheme] = useState(() => {
    try {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        const parsed = JSON.parse(savedTheme);
        // On vérifie que l'objet parsé contient bien la propriété darkTheme
        if (parsed && typeof parsed.darkTheme !== 'undefined') {
          return parsed;
        }
      }
    } catch (error) {
      console.error("Erreur lors de la lecture du thème dans localStorage:", error);
    }

    // Si le localStorage est vide ou corrompu, on sauvegarde et retourne le thème initial
    localStorage.setItem('theme', JSON.stringify(intialTheme));
    return intialTheme;
  });

  // 1. LA FONCTION DOIT ÊTRE DÉCLARÉE ICI (Vérifiez son orthographe)
  const editLocalStorageTheme = (newTheme) => {
    localStorage.setItem('theme', JSON.stringify(newTheme));
  };


  // Gestion de la classe CSS du body
  useEffect(() => {
    if (themeState.darkTheme) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [themeState.darkTheme]);


  return (
    <BrowserRouter>
      <AuthProvider>
        <NavBar theme={themeState}
          setTheme={setStateTheme}
          editLocalStorageTheme={editLocalStorageTheme}
        />

        <
          AudioEngine />

        <ToastContainer position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick rtl={false}
          pauseOnFocusLoss draggable pauseOnHover theme="dark"
          style={{ top: "60px" }}
        />

        <Routes>
          <Route exact path='/' element={< Home />} />
          <Route exact path='/connexion' element={< SignIn />} />
          <Route exact path='/inscription' element={< SignUp />} />
          <Route exact path='/motdepassereset' element={< ForgetPassword />} />

          <Route element={< ProtectedRoute />} >
            <Route exact path='/actions' element={< Layout />} />
            <Route exact path="/utilisateur/dashboard" element={< Dashboard />} />
            <Route exact path="/utilisateur/profile" element={< Profile />} />
            <Route exact path="/utilisateur/note" element={< Note />} />
            <Route exact path="/utilisateur/calendar" element={< Calendar />} />
            <Route exact path="/admin" element={< AdminDashboard />} />
            <Route exact path="/compte" element={< ComptePersonnel />} />
            <Route exact path="/culture" element={< Culture />} />
            <Route exact path="/compteur" element={< TotalBattle />} />
            <Route exact path="/minuteur" element={< Minuteur />} />
          </Route >

          <Route path='*' element={< NotPageFound />} />
        </Routes >
        <Footer />
      </AuthProvider>
    </BrowserRouter >
  );
}

export default App;